import * as React from 'react';
import cn from 'classnames';
import { Link, Money, Tooltip } from '../../../index';
import { useTheme } from '../../../theme';
import { useCallback } from 'react';
import { useToggleable } from '../../../hooks';
var FareSelect = function (props) {
    var fares = props.fares, onSelect = props.onSelect, onOpenModal = props.onOpenModal;
    var css = useTheme('FlightSelect').FareSelect;
    var handleSelect = useCallback(function (fare) {
        var select = onSelect(fare);
        select();
    }, [fares, onSelect]);
    var renderTooltipContent = useCallback(function (fare) {
        var _a;
        return (React.createElement(React.Fragment, null, (_a = fare.prices[0]) === null || _a === void 0 ? void 0 : _a.flight.fares[0].passengerFares.map(function (passengerFare) { return (React.createElement("div", { key: passengerFare.totalFare.amount },
            passengerFare.taxes.map(function (tax) { return (React.createElement("div", { key: tax.code, className: css.fee },
                "Fee ",
                tax.code,
                " ",
                React.createElement(Money, { money: tax.price }))); }),
            React.createElement("div", { className: cn(css.fee, css.active) },
                "Tariff ",
                React.createElement(Money, { money: passengerFare.baseFare })),
            React.createElement("div", { className: cn(css.fee, css.active) },
                "Total ",
                React.createElement(Money, { money: passengerFare.totalFare })))); })));
    }, [fares]);
    var renderFareInfo = useCallback(function (fare, i) {
        var _a;
        var _b, _c, _d;
        var _e = useToggleable(false), isOpen = _e.isOpen, open = _e.open, close = _e.close;
        if (!fare.prices || !((_b = fare.prices[0]) === null || _b === void 0 ? void 0 : _b.price)) {
            return null;
        }
        return (React.createElement("div", { onMouseEnter: open, onMouseLeave: close, className: css.fare, key: fare.fareFamily.title },
            React.createElement("span", { className: css.code }, (_c = fare.prices[0]) === null || _c === void 0 ? void 0 : _c.flight.fares[0].passengerFares[0].priceClasses[0].classCode),
            React.createElement(Link, { className: css.name, action: function (e) {
                    // do not show modal if the user clicks on a specific tariff
                    e.stopPropagation();
                    handleSelect(fare);
                } },
                React.createElement(Tooltip, { title: renderTooltipContent(fare), placement: 'bottom', tooltipClassName: css.tooltip, open: isOpen },
                    React.createElement("span", { className: css.name__inner }, fare.fareFamily.title)),
                React.createElement(Money, { money: (_d = fare.prices[0]) === null || _d === void 0 ? void 0 : _d.price, moneyClassName: cn(css.price, (_a = {}, _a[css.bold] = i === 0, _a)) }))));
    }, [fares, onSelect]);
    return (React.createElement("div", { onClick: onOpenModal, className: css.wrapper }, fares.map(renderFareInfo)));
};
export default FareSelect;
